export function formatTimeDisplay(seconds: number, style: "verbose" | "digital" = "verbose"): string {
  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  if (style === "digital") {
    if (hours > 0) {
      return [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
        String(remainingSeconds).padStart(2, "0"),
      ].join(":");
    }

    return [String(minutes).padStart(2, "0"), String(remainingSeconds).padStart(2, "0")].join(":");
  }

  const hourPart = hours > 0 ? `${hours}h` : "";
  const minutePart = minutes > 0 ? `${minutes}m` : "";
  const secondPart = remainingSeconds > 0 ? `${remainingSeconds}s` : "";

  return [hourPart, minutePart, secondPart].filter(Boolean).join(" ") || "0s";
}
